// extracted by mini-css-extract-plugin
module.exports = {"root":"SubmitButton_root__YZIZ0","icon":"SubmitButton_icon__xuWFl","label":"SubmitButton_label__BVQJF"};